<template>
  <div class="page-item">
    <MdScroll id="collect" :class="{'hasBottom':isEdit}" :url="url" :filterData="filterData" @getList="getList">
      <div v-show="!item.isDelete" v-for="item in list" :key="item.Id" class="item">
        <transition name="van-slide-left">
          <van-checkbox v-show="isEdit" class="item-checked" checked-color="#F03549" v-model="item.checked"></van-checkbox>
        </transition>
        <div class="item-content">
          <FormworkOne :row="item"></FormworkOne> 
          <FormworkTwo class="mart-15" :row="item"></FormworkTwo>        
        </div>
      </div>
      <EmptyPosition v-show="!list.length" type="fav"></EmptyPosition>
    </MdScroll>
  </div>
</template>

<script>
import FormworkOne from '../components/formworkOne'
import FormworkTwo from '../components/formworkTwo'
import MdScroll from '@/components/mdScroll/mdScroll'
import EmptyPosition from '@/components/common/emptyPosition'
import { Cms } from '@/api'


export default {
  name: "collect",
  components: { FormworkOne, FormworkTwo, MdScroll, EmptyPosition },
  data() {
    return {
      list: [],
      TotalRecord: 0,
      Ids: [],
      isEdit: false,
      filterData: {
        UserId: this.$mdUtils.getUserInfo('Id'),
        PageIndex: 1,
        PageSize: 10
      },
      url: Cms.QueryFavArticleByPage
    }
  },
  watch: {
    list: {
      handler: function () {
        this.Ids = []
        this.list.forEach(item => {
          if (item.checked) this.Ids.push(item.Id)
        })
        this.$emit('getCheckIds', this.Ids)
      },
      deep: true
    }
  },
  methods: {
    async getList(list) {
      this.list = list.map(item => {
        this.$set(item, 'checked', false)
        this.$set(item, 'isDelete', false)
        return item
      })
    },
    async submit() {
      if (this.Ids && this.Ids.length) {
        await this.$api(Cms.FavMultiDelete, { Ids: this.Ids })
        this.$emit('onSuccess')
        this.onSuccess()
        this.$tips.toast()
      }
    },
    onSuccess() {
      this.list.forEach(item => {
        let index = this.Ids.findIndex(subItem => item.Id === subItem)
        index >= 0 && this.$set(item, 'isDelete', true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hasBottom {
  bottom: 40px !important;
}
.item {
  display: flex;
  position: relative;
  padding: 25px;
  left: 0;
  &::after {
    @include line;
  }
  align-items: flex-start;
  &-checked {
    position: relative;
    top: 15px;
    margin-right: 20px;
    flex: none;
  }
  &-content {
    flex: auto;
  }
}
</style>

